export default __webpack_public_path__ + "static/media/SERVICIOS_PIEZAS.39867345.png";